var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image 21 (traced)",
    clipPath: "url(#clip0_39_6956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.00762 0.25C5.88887 0.267188 5.78574 0.301563 5.64824 0.371875C5.54668 0.423438 5.38574 0.58125 3.34668 2.61563C2.12949 3.83125 1.14199 4.82969 1.12637 4.85938C1.11074 4.88906 0.90293 5.50625 0.663867 6.22969L0.229492 7.54375L0.256055 7.61563C0.288867 7.7 0.35918 7.75 0.44668 7.75C0.48418 7.75 1.00762 7.58438 1.82793 7.31094L3.14824 6.87188L5.36074 4.65781C7.43731 2.58125 7.57637 2.43906 7.63106 2.33281C7.79043 2.02188 7.79043 1.65 7.62949 1.33906C7.57949 1.24063 7.52012 1.175 7.17324 0.826563C6.80762 0.462501 6.76231 0.421875 6.64824 0.364063C6.44668 0.259376 6.21856 0.220313 6.00762 0.25ZM6.41387 0.726563C6.49043 0.7625 6.57012 0.83125 6.85606 1.11563C7.16074 1.41719 7.21231 1.475 7.25918 1.57031C7.34981 1.75313 7.34512 1.97656 7.24668 2.13906C7.21074 2.19844 6.95606 2.46875 6.93574 2.46875C6.92793 2.46875 6.60606 2.15156 6.21699 1.7625L5.51074 1.05625L5.65449 0.91875C5.86231 0.71875 5.97168 0.66875 6.18731 0.676563C6.29356 0.681251 6.33887 0.690625 6.41387 0.726563ZM5.91856 2.08281L6.62481 2.78906L4.83574 4.57813L3.04668 6.36719L2.33574 5.65625L1.6248 4.94531L3.40918 3.16094C4.39199 2.17813 5.19824 1.375 5.20293 1.375C5.20762 1.375 5.52949 1.69375 5.91856 2.08281ZM1.72324 6.89219C1.21699 7.06094 0.80293 7.19688 0.801367 7.19531C0.798242 7.19531 0.935742 6.77969 1.10293 6.275L1.40918 5.35625L2.0248 5.97031L2.64043 6.58594L1.72324 6.89219Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_6956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1125c0fcb9a1c7160b6344ba2e4c4dff.svg";
export { ForwardRef as ReactComponent };